import React from "react";

const VERTICALS = [
  {
    icon: "bi-shop",
    title: "Retailer",
    text: "Pushes fast inventory turns, customer specials, and new arrivals directly into local shopping corridors",
    tags: ["Shop", "New Products", "Special Offers", "Popular Products"],
    activeTag: "Seasonal Products",
  },
  {
    icon: "bi-gear-wide-connected",
    title: "Manufacturer",
    text: "Broadcasting facility capacity, bulk line runs, and connecting with supply chain procurement networks",
    tags: ["Products", "Production Capacity", "Wholesale Opportunities", "Retailer Connections"],
    activeTag: "Regional Markets",
  },
  {
    icon: "bi-building",
    title: "Wholesaler",
    text: "Connecting batch availability, warehousing logistics, and contract distributors across commercial districts",
    tags: ["Wholesale Products", "Retailers", "Businesses", "Bulk Opportunities"],
    activeTag: "Regional Availability",
  },
  {
    icon: "bi-person-workspace",
    title: "Service Provider",
    text: "Highlighting specialist certifications, regional dispatch zones, and corporate contracting qualifications",
    tags: ["Service", "Location", "Capability", "Availability", "Target Customers"],
    activeTag: "Opportunities",
  },
];

export default function SectorExecution() {
  return (
    <section className="section-py">
      <div className="container-selectezi">
        <div className="section-head">
          <span className="eyebrow-label">Sector Execution</span>
          <h3 className="section-title">Continuous Promotion, Not Just a Profile</h3>
          <p className="section-subtitle mx-auto">
            The Marketing Agent continuously works to maintain promotional
            activity within SELECTEZI, tailoring structured tactical
            sequences specifically to industry operations.
          </p>
        </div>

        <div className="row g-4">
          {VERTICALS.map((v) => (
            <div className="col-lg-6" key={v.title}>
              <div className="vertical-card">
                <span className="icon-badge">
                  <i className={`bi ${v.icon}`} />
                </span>
                <div className="vertical-eyebrow mt-3">Commercial Vertical</div>
                <div className="vertical-title">{v.title}</div>
                <p className="vertical-desc">{v.text}</p>

                <div className="d-flex flex-wrap align-items-center gap-2">
                  {v.tags.map((tag, i) => (
                    <React.Fragment key={tag}>
                      <span className="tag-pill">{tag}</span>
                      <i className="bi bi-arrow-right tag-arrow" />
                    </React.Fragment>
                  ))}
                  <span className="tag-pill is-active">{v.activeTag}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
